/**
 * TanStack Query hook for the Slide Sense module config (presenter-mode
 * availability). Returns effective presenter modes with a fail-open default
 * of "both enabled" while loading or on error, so a config hiccup never
 * accidentally hides presenting for everyone.
 */

import { useQuery } from "@tanstack/react-query"

import type { SlideSenseModuleConfig, SlideSensePresenterModes } from "../api"

import { fetchModuleConfig } from "../api"

export const DEFAULT_PRESENTER_MODES: SlideSensePresenterModes = {
  presentation: true,
  presenter_view: true,
}

export function useModuleConfig() {
  return useQuery<SlideSenseModuleConfig>({
    queryKey: ["slide-sense", "module-config"],
    queryFn: () => fetchModuleConfig(),
    staleTime: 5 * 60 * 1000,
  })
}

/**
 * Effective presenter-mode availability, defaulting both to enabled until
 * (and unless) the config says otherwise.
 */
export function usePresenterModes(): SlideSensePresenterModes {
  const { data } = useModuleConfig()
  return data?.presenter_modes ?? DEFAULT_PRESENTER_MODES
}
